import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Product } from '../model/product';
import { HomeService } from '../services/home/home.service';
import { ProductService } from "../services/product/product.service";
import { CategoryService } from '../services/category/category.service';
import { environment } from "../../environments/environment";
import { CartService } from "../services/cart/cart.service";

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.css']
})
export class ProductDetailComponent implements OnInit {

  product;
  similarProducts;
  productF1;
  productF2;
  productF3;
  fournisseur;
  card=[];
  favoris =[];
  qte = '1';
  det;
  existInCard;
  existFavoris = false;
  baseUrl = environment.baseUrl
  pdf:any ="http://102.53.9.162/ceratube/assets/images/DESCRIPTIF/";
  progress = 0;
  typeCompte
  constructor(private homservice:HomeService,private route: ActivatedRoute,private productService:ProductService,
    private categoryService:CategoryService,private cartService:CartService) {
      this.typeCompte = localStorage.getItem('typeCompte');
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.progress = 100
      setTimeout(() => {
        this.progress = 0
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }, 1500);
      this.productService.productByCode(params.id).subscribe(res =>{
        // this.product = [];
        this.product = res;
        this.pdf = this.product["produit"].TIT3_1.IMG[1];
        this.qte = this.product.details.DET
        this.det = this.product.details.DET
        // this.det = 4
        this.productService.productByCategory(this.product.details.TSICOD2,1).subscribe(res => {
          this.similarProducts = res['produits'];
        });
        if(localStorage.getItem('favoris')) {
          this.existFavoris = this.isProduitExistInFavoris(this.product.details.ITMREF);
        }
        this.categoryService.allCategories().subscribe(res =>{
          this.productF1 = res['categories'][this.product.details.TSICOD0];
          this.productF2 = this.productF1.categorie[this.product.details.TSICOD1];
          this.productF3 = this.productF2.categories[this.product.details.TSICOD2];
          this.fournisseur = res['fournisseurs'][this.product.details.TSICOD4];
        });

      })
    })

    if (localStorage.getItem('card')) {
      this.card = JSON.parse(localStorage.getItem('card'));

    }


  }

  addToCard(product)
  {

    if (this.qte) {
      if (!this.isProduitExistInCard(product.details.ITMREF)) {
        var tempArray = this.card;
        this.card.push({product:product.details,item_quantity:parseInt(this.qte)});
        // this.card = this.card.concat(tempArray);
        this.cartService.panierCount++;
        this.cartService.addTocart({
          "item_ref" : product.details.ITMREF,
          "item_quantity" : this.qte,
          "item_price" : product.details.PRIXNET
        }).subscribe(res=>{
          console.log(res);
        });

      }else{
        this.card.forEach(itemCard => {
          if (product.details.ITMREF==itemCard.product.ITMREF) {
            itemCard.item_quantity+=parseInt(this.qte);
            this.cartService.updateItemCart([{
                "item_ref": product.details.ITMREF,
                "item_quantity": itemCard.item_quantity
            }]).subscribe(res=>console.log(res))
          }
        });
      }

      localStorage.setItem('card', JSON.stringify(this.card));
    }else{
      alert("vous devez remplir la quantité");
    }

  }


  addToFavoris(product)
  {
    if (JSON.parse(localStorage.getItem('favoris'))!=null && JSON.parse(localStorage.getItem('favoris'))!=undefined) {
      this.favoris = JSON.parse(localStorage.getItem('favoris'));
    }else{
      this.favoris = [];
    }
    if (!this.isProduitExistInFavoris(product.details.ITMREF)) {
        this.favoris.push(product.details);
        this.existFavoris = true;
        this.cartService.favorisCount++;
    }else{
        alert("Ce produit est déjà dans vos favoris");
    }
    localStorage.setItem('favoris', JSON.stringify(this.favoris));
  }

  isProduitExistInCard(id)
  {
    var exit = false;
    this.card.forEach(item => {
      if (id==item.product.ITMREF) {
        exit =  true;
      }
    });

    return exit;
  }
  changeQte(){
    if(this.qte>=this.det && this.det != 0){
      var q = parseInt(this.qte)/parseInt(this.det)
      this.qte = ''+(parseInt(this.det)*parseInt(q.toFixed()))
    }else{

      this.qte = ''+(parseInt(this.det))
    }

  }
  isProduitExistInFavoris(id)
  {
    var exit = false;
    this.favoris.forEach(item => {
      if (id==item.ITMREF) {
        exit =  true;
      }
    });

    return exit;
  }



}
